export default {
  metadata: {
    version: '1.0.0',
    id: 'input-field-1.0.0',
    name: 'JDSInputField',
    description:
      "A input field give context to the information that a user needs to input. They're commonly used in forms."
  },
  hierarchy: {
    container: [
      {
        'field-container': [
          'input_label-jds-text',
          {
            'input-container': [
              {
                'prefix-container': ['prefix-slot']
              },
              'jds_input',
              'suffix-slot'
            ]
          }
        ]
      },
      {
        'active-line-container': ['feedback-container']
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    container: {
      'flex-direction': '{i_0}',
      gap: '{i_1}',
      width: '{i_2}',
      'justify-content': '{i_3}',
      'align-items': '{i_4}',
      opacity: '{i_30}',
      behavior: {
        hover: {}
      }
    },
    'field-container': {
      'flex-direction': '{i_5}',
      width: '{i_6}',
      'align-items': '{i_7}',
      'justify-content': '{i_8}',
      'padding-bottom': '{i_9}',
      'animate-stack-alignment': true
    },
    'input-container': {
      'flex-direction': '{i_10}',
      'justify-content': '{i_11}',
      width: '{i_12}',
      gap: '{i_13}',
      'padding-top': 20,
      'align-items': '{i_14}',
      'z-index': 0
    },
    'prefix-container': {
      hidden: false
    },
    jds_input: {
      disabled: false,
      type: 'text',
      textAlign: '{i_17}',
      rows: 1,
      flex: 1
    },
    'active-line-container': {
      'flex-direction': '{i_21}',
      width: '{i_22}',
      'align-items': '{i_23}',
      'padding-bottom': 1,
      'padding-top': 1
    },
    'feedback-container': {
      width: '{i_24}',
      height: 2,
      'background-color': '{i_25}',
      'border-radius': 48,
      show: true,
      behavior: {
        hover: {
          'background-color': '{i_26}'
        },
        focus: {
          'background-color': '{i_27}'
        },
        active: {
          'background-color': '{i_28}'
        }
      }
    },
    jds_feedback_block: {
      size: 's',
      state: 'none'
    },
    'prefix-slot': {
      disabled: false
    },
    'suffix-slot': {
      disabled: false
    },
    'input_label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      textType: 'label',
      maxLines: 1,
      'z-index': 1,
      'animate-padding-left': true
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    disabled: {
      true: {
        container: {
          opacity: '{i_29}',
          disabled: true
        },
        jds_input: {
          disabled: true
        },
        'prefix-slot': {
          disabled: true
        },
        'suffix-slot': {
          disabled: true
        }
      }
    },
    state: {
      success: {
        'feedback-container': {
          'background-color': '{i_31}',
          behavior: {
            hover: {
              'background-color': '{i_32}'
            },
            focus: {
              'background-color': '{i_33}'
            },
            active: {
              'background-color': '{i_34}'
            }
          }
        },
        jds_feedback_block: {
          state: 'success'
        }
      },
      error: {
        'feedback-container': {
          'background-color': '{i_35}',
          behavior: {
            hover: {
              'background-color': '{i_36}'
            },
            focus: {
              'background-color': '{i_37}'
            },
            active: {
              'background-color': '{i_38}'
            }
          }
        },
        jds_feedback_block: {
          state: 'error'
        }
      },
      warning: {
        'feedback-container': {
          'background-color': '{i_39}',
          behavior: {
            hover: {
              'background-color': '{i_40}'
            },
            focus: {
              'background-color': '{i_41}'
            },
            active: {
              'background-color': '{i_42}'
            }
          }
        },
        jds_feedback_block: {
          state: 'warning'
        }
      }
    },
    type: {
      email: {
        jds_input: {
          type: 'email'
        }
      },
      number: {
        jds_input: {
          type: 'number'
        }
      },
      password: {
        jds_input: {
          type: 'password'
        }
      },
      phone: {
        jds_input: {
          type: 'phone'
        }
      }
    },
    _hasSuffix: {
      true: {
        'suffix-icon-container': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      true: {
        true: {
          'field-container': {
            'align-items': '{i_43}'
          },
          'prefix-icon-container': {
            hidden: false
          },
          'input_label-jds-text': {
            'font-family': '{text_147}',
            'font-size': '{text_146}',
            'line-height': '{text_148}',
            'letter-spacing': '{text_149}',
            'font-weight': '{text_150}',
            'padding-left': 0
          }
        },
        false: {
          'field-container': {
            'align-items': '{i_44}'
          },
          'input_label-jds-text': {
            'font-family': '{text_147}',
            'font-size': '{text_146}',
            'line-height': '{text_148}',
            'letter-spacing': '{text_149}',
            'font-weight': '{text_150}',
            'padding-left': 0
          }
        }
      },
      false: {
        true: {
          'field-container': {
            'align-items': '{i_45}'
          },
          'prefix-icon-container': {
            hidden: false
          }
        },
        false: {
          'field-container': {
            'align-items': '{i_47}'
          },
          'input_label-jds-text': {
            'padding-left': 0
          }
        }
      }
    },
    {
      none: {
        true: {
          'feedback-container': {
            'background-color': '{i_48}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['_labelFocus', '_hasPrefix'],
    ['state', '_inputFocus']
  ],
  api: {
    children: {
      'prefix-slot': {
        name: 'prefix',
        accepts: [
          'jds_dropdown',
          'jds_icon',
          'jds_input_phone_dropdown',
          'jds_text'
        ],
        max: 1,
        doc_description: "It takes 'icon' or 'dropdown' as prefix."
      },
      'suffix-slot': {
        name: 'suffix',
        accepts: ['jds_dropdown', 'jds_icon', 'jds_spinner'],
        max: 1,
        doc_description: "It takes 'icon' or 'dropdown' as suffix."
      }
    },
    config: {
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable InputField.'
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        doc_description:
          "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.",
        values: ['none', 'success', 'error', 'warning']
      },
      type: {
        type: 'JDSInput.type',
        function: true,
        values: [
          'text',
          'email',
          'number',
          'password',
          'textarea',
          'pin',
          'phone'
        ]
      },
      _labelFocus: {
        values: [false, true]
      },
      _inputFocus: {
        values: [false, true]
      },
      _hasPrefix: {
        values: [false, true]
      },
      _hasSuffix: {
        values: [false, true]
      }
    },
    data: {
      jds_input: {
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        },
        value: {
          type: 'string',
          name: 'value',
          doc_description: 'It takes value from user for the Input field.'
        },
        name: {
          type: 'string',
          name: 'name'
        },
        autoFocus: {
          type: 'boolean',
          name: 'autoFocus',
          platform: 'web'
        },
        placeholder: {
          type: 'string',
          name: 'placeholder',
          doc_description: 'It displays the placeholder of Input field.'
        },
        maxLength: {
          type: 'number',
          name: 'maxLength',
          doc_description:
            "It can be used to bound user's input within a maximum character limit."
        },
        pattern: {
          type: 'string',
          name: 'pattern'
        },
        required: {
          type: 'boolean',
          name: 'required',
          doc_description: 'It can be used to make input field required.'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        },
        capitalization: {
          type: 'keyboardCapitalization',
          name: 'capitalization',
          platform: 'android'
        },
        semantics: {
          type: 'string',
          name: 'semantics',
          platform: 'android'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        }
      },
      'input_label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          function: true
        },
        id: {
          type: 'string',
          name: 'id',
          platform: 'web'
        },
        'padding-left': {
          type: 'size',
          name: '_labelOffset'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It dispalys helper text of the input field.'
        }
      }
    },
    events: {
      'prefix-container': {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        }
      },
      jds_input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onInvalid: 'onInvalid',
        onSubmit: 'onSubmit'
      },
      'prefix-slot': {
        onClick: 'onPrefixClick',
        onSlotMeasure: {
          name: 'onPrefixSlotWidth',
          platform: 'android'
        }
      },
      'suffix-slot': {
        onClick: 'onSuffixClick'
      }
    },
    a11y: {
      jds_input: {
        properties: {
          ariaLabel: {
            name: 'ariaLabel',
            prop: 'label'
          },
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          ariaInvalid: 'ariaInvalid',
          ariaPlaceholder: {
            name: '_ariaplaceholder',
            prop: 'placeholder'
          },
          ariaRequired: {
            name: '_ariaRequired',
            prop: 'required'
          }
        }
      }
    }
  }
};
